/* eslint-disable no-case-declarations */
import BasePriceCalculator from 'app/helpers/productSpecificPriceCalculators/basePriceCalculator';

// Key is a number of months
export const LOVER_SUBSCRIPTION_MONTHLY_COST = {
  '2_5_mg': {
    1: 99_99,
    3: 84_99,
    12: 69_99,
  },
  '5_mg': {
    1: 149_99,
    3: 129_99,
    12: 109_99,
  },
  '4': {
    1: 59_99,
    3: 49_99,
    12: 39_99,
  },
  '8': {
    1: 109_99,
    3: 89_99,
    12: 69_99,
  },
  '12': {
    1: 159_99,
    3: 134_99,
    12: 119_99,
  },
};

export const LOVER_SUBSCRIPTION_MONTHLY_COST_VARIANT_2 = {
  '2_5_mg': {
    1: 79_99,
    3: 69_99,
    12: 59_99,
  },
  '5_mg': {
    1: 109_99,
    3: 89_99,
    12: 69_99,
  },
  '4': {
    1: 39_99,
    3: 34_99,
    12: 29_99,
  },
  '8': {
    1: 79_99,
    3: 69_99,
    12: 59_99,
  },
  '12': {
    1: 119_99,
    3: 104_99,
    12: 89_99,
  },
};

export const LOVER_SUBSCRIPTION_MONTHLY_COST_EXP_V1 = {
  '2_5_mg': {
    1: 89_99,
    3: 84_99,
    12: 69_99,
  },
  '5_mg': {
    1: 129_99,
    3: 129_99,
    12: 109_99,
  },
  '4': {
    1: 69_99,
    3: 49_99,
    12: 39_99,
  },
  '8': {
    1: 99_99,
    3: 89_99,
    12: 69_99,
  },
  '12': {
    1: 119_99,
    3: 134_99,
    12: 119_99,
  },
};

export const LOVER_SUBSCRIPTION_MONTHLY_COST_EXP_V2 = {
  '2_5_mg': {
    1: 89_99,
    3: 84_99,
    12: 69_99,
  },
  '5_mg': {
    1: 109_99,
    3: 129_99,
    12: 109_99,
  },
  '4': {
    1: 69_99,
    3: 49_99,
    12: 39_99,
  },
  '8': {
    1: 89_99,
    3: 89_99,
    12: 69_99,
  },
  '12': {
    1: 109_99,
    3: 134_99,
    12: 119_99,
  },
};

class LoverPriceCalculator extends BasePriceCalculator {
  dailyStrength: string | null;
  numberOfDoses: 4 | 8 | 12 | null;
  otherActiveSubscription: boolean;
  expVariant: string | null;

  SHIPPING_PRICE = 9_99;

  constructor(
    includeBB: boolean,
    includeBBonAnotherProtocol: boolean,
    intakeName: string,
    dailyStrength: string | null = null,
    numberOfDoses: null | 4 | 8 | 12 = null,
    multiMonthPlan: 1 | 3 | 12,
    otherActiveSubscription: boolean,
    expVariant: string | null = null,
  ) {
    super(includeBB, includeBBonAnotherProtocol, intakeName, multiMonthPlan);

    this.dailyStrength = dailyStrength;
    this.numberOfDoses = numberOfDoses;
    this.otherActiveSubscription = otherActiveSubscription;
    this.expVariant = expVariant;
  }

  monthlyCost() {
    if (!this.numberOfDoses && !this.dailyStrength) return 0;

    const subProduct = (
      this.numberOfDoses ? this.numberOfDoses : !!this.dailyStrength && this.dailyStrength
    ).toString();

    const bloodflow_variant_2 = this.expVariant === 'bloodflow_multimonth_variation_2';

    let priceConfig = bloodflow_variant_2 ? LOVER_SUBSCRIPTION_MONTHLY_COST_VARIANT_2 : LOVER_SUBSCRIPTION_MONTHLY_COST;

    switch (this.expVariant) {
      case 'bloodflow_pricing_q1_25_variation_1':
        priceConfig = LOVER_SUBSCRIPTION_MONTHLY_COST_EXP_V1;
        break;
      case 'bloodflow_pricing_q1_25_variation_2':
        priceConfig = LOVER_SUBSCRIPTION_MONTHLY_COST_EXP_V2;
        break;
      default:
        // Keep the initial pricing based on bloodflow_multimonth experiment
        break;
    }

    return priceConfig[subProduct][this.multiMonthPlan];
  }

  subscriptionCost() {
    if (this.subscriptionPaid) return 0;

    return (this.monthlyCost() + (this.includeBB ? this.BB_PRICE : 0)) * this.multiMonthPlan;
  }

  totalDueTodayForCurrentProduct() {
    if (!this.intakeName.includes('onboarding')) {
      return 0;
    }

    return this.subscriptionCost() + this.shippingPrice();
  }

  freeShipping() {
    return !(!this.otherActiveSubscription && this.subscriptionCost() <= 10000);
  }

  shippingPrice() {
    return this.freeShipping() ? 0 : this.SHIPPING_PRICE;
  }
}

export default LoverPriceCalculator;
